<template>
  <Popup :closePopupEvent="closePopup" :width="width">
    <h6 slot="header">Report An Issue</h6>
    <div class="cnt-support-form">
      <form
        @submit.prevent="contactSupportCB"
        autocomplete="off">

        <FormError
          v-show="formError"
          :message="formError"
          class="cnt-supp-form-error" />

        <input
          autocomplete="false"
          name="hidden"
          type="text"
          style="display:none;">

        <div class="vlt-input-group">
          <label class="report-label">Title</label>
          <input
            type="text"
            v-model="title" maxlength="50">
        </div>

        <div class="vlt-input-group">
          <label class="report-label" style="margin-bottom:10px;">Description</label>
          <textarea
            rows="4"
            class="form-textarea-inp"
            v-model="message"
            :maxLength="maxLength">
          </textarea>
        </div>
        <p class="remaining"><span id="chars">256</span> characters</p>

        <button
        type="submit"
        class="btn-lg-primary" aria-label="Submit button">
          Submit
        </button>

      <Loading v-show="showLoading"></Loading>

      </form>
    </div>
  </Popup>
</template>

<script>
import Popup from '@/components/Slots/Popup.vue';
import FormError from '@/components/Templates/FormError.vue';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import Loading from '@/components/Templates/Loading.vue';

export default {
  name: 'PopupContactSupport',
  props: [ 'closePopup' ],
  data () {
    return {
      formError: '',
      title: '',
      message: '',
      width: '30%',
      maxLength: 256,
      showLoading: false
    };
  },
  computed: {
    ...mapGetters([
      'AppUser'
    ])
  },
  components: {
    Popup,
    FormError,
    Loading
  },
  created () {
    this.CommitConfigStore();
  },
  mounted () {
    $('textarea').keyup(function() {
      var length = $(this).val().length;
      var length = this.maxLength-length;
      $('#chars').text(length);
    });
  },
  methods: {
    ...mapMutations([
      'CommitConfigStore'
    ]),
    ...mapActions([
      'actNotifyVendor'
    ]),
    contactSupportCB () {
      if (!this.isFormValid()) return;
      this.showLoading = true;

      let data = {
        email: this.AppUser.email,
        title: 'Dear Support Team',
        subject: this.title,
        message: this.message
      };

      this.actNotifyVendor(data).then(response => {

      this.showLoading = false;

        if (response.error) {
          this.formError = response.reason;
        } else {
          this.closePopup();
        }
      }).catch(error => {
        // console.log('[Subscribe updatePasswordCB error]', error);
      });
    },
    isFormValid () {
      return this.isTitleValid() && this.isMessageValid();
    },
    isTitleValid () {
      if (!this.title) {
        this.formError = 'Title is required';
        return false;
      } else if (this.title.startsWith(" ")) {
        this.formError = 'Remove Space At Beginning';
        return false;
      }

      this.formError = '';
      return true;
    },
    isMessageValid () {
      if (!this.message) {
        this.formError = 'Message is required';
        return false;
      } else if (this.message.startsWith(" ")) {
        this.formError = 'Remove Space At Beginning';
        return false;
      }

      this.formError = '';
      return true;
    }
  }
}
</script>

<style lang="scss">
.cnt-support-form {
  margin: 7% 10%;
  .vlt-input-group {
    margin-bottom: 15px;
  }
  .form-textarea-inp {
    height: 100px;
    resize: none;
  }
}
.cnt-supp-form-error {
  margin-bottom: 10px;
}
.remaining{
  text-align: end;
  margin-bottom: 25px;
  color: rgba(0, 0, 0, 1);	
  font-family: "ProximanovaRegular";	
  font-size: 14px;
  font-style: normal;
}
.report-label{
  font-family: "ProximanovaBold";	
}
</style>



// WEBPACK FOOTER //
// src/components/Popups/ContactSupport.vue